<template>
    <div>
        <div class="row">
            <input-text class="col-12 col-md-4" label="Codigo do projeto" v-model="codigoProjeto"/>
            <input-select class="col-12 col-md-4" label="Fase de inovação" :options="fasesInovacao" v-model="faseInovacao"/>
            <input-select class="col-12 col-md-4" label="Status" :options="status" v-model="statusFiltro"/>
            
            <input-select class="col-12 col-md-3" :min="1998" :label="'Ano inicial'" :options="anos" v-model="anoInicial"/>
            <input-select class="col-12 col-md-3" :disabled="!anoInicial" label="Mês inicial" :options="mesesFiltrado" v-model="mesInicial"/>
            <input-select class="col-12 col-md-3" :disabled="!anoInicial" :min="1998" :label="'Ano final'" :options="anosFiltrado" v-model="anoFinal"/>
            <input-select class="col-12 col-md-3" :disabled="!anoInicial" label="Mês final" :options="mesesFiltrado" v-model="mesFinal"/>
        
            <div class="col-12 d-flex mt-2">
                <b-button variant="success" @click="filtrar()">
                    <i class="fas fa-search mr-2"></i>
                    Filtrar
                </b-button>
                <b-button variant="outline-primary" @click="limpar" class="ml-2">
                    Limpar
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import helpers from "@/common/utils/helpers";
export default {
    props : {
        filtro : {
            default : () => {
                return {};
            }
        },
    },
    components : {
        InputText,
        InputSelect
    },
    data : () => ({
        anos : [],
        meses : [],
        fasesInovacao : [],
        status : [],    

        codigoProjeto : "",
        faseInovacao : null,
        statusFiltro : null,
        anoInicial : null,
        anoFinal : null,
        mesInicial : null,
        mesFinal : null,
    }),
    mounted(){
        this.inicializar();
    },
    methods : {
        inicializar : function(){
            this.fasesInovacao = [
                {text : "Todas", value : null},
                ...helpers.FaseInovacao
            ]

            this.status = [
                {text : "Todos", value : null, variant : null},
                ...helpers.StatusPropostaProjeto
            ]

            this.meses = [{text : "Todos meses", value : null}, ...helpers.retornarMeses(),];
            let ano = new Date().getFullYear();
            this.anos = [];
            this.anos.push({
                text : "Todos anos",
                value : null,
            });
            for (let index = ano; index >= 1998; index--) {
                this.anos.push(index);            
            }
        },

        filtrar : function(){
            let filtro = {
                codigoProjeto : this.codigoProjeto,
                faseInovacao : this.faseInovacao,
                status : this.statusFiltro,
                DataInicio : !this.anoInicial ? null : `${this.anoInicial}-${this.mesInicial}-01`,
                DataFim : !this.anoFinal ? null : `${this.anoFinal}-${this.mesFinal}-01`,
            }
            
            this.$emit('buscar', filtro);
        },

        limpar : function(){
            this.codigoProjeto = "";
            this.faseInovacao = null;
            this.statusFiltro = null;
            this.anoInicial = null;
            this.anoFinal = null;
            this.mesInicial = null;
            this.mesFinal = null;
        },
    },
    watch : {
        filtro : {
            handler : function(){
                this.codigoProjeto = this.filtro.codigoProjeto || "";
                this.faseInovacao = this.filtro.faseInovacao || null;
                this.statusFiltro = this.filtro.status || null;
                
                this.anoInicial = this.filtro.DataInicio != null ? this.filtro.DataInicio.split("-")[0] : null;
                this.anoFinal = this.filtro.DataFim != null ? this.filtro.DataFim.split("-")[0] : null;
                this.mesInicial = this.filtro.DataInicio != null ? this.filtro.DataInicio.split("-")[1] : null;
                this.mesFinal = this.filtro.DataFim != null ? this.filtro.DataFim.split("-")[1] : null;
            },
            immediate : true,
        },
        anoInicial : function(valor){
            if(!valor){
                this.mesInicial = null;
                this.mesFinal = null;
                this.anoFinal = null;
                return;
            }

            if(this.anoFinal < valor){
                this.anoFinal = valor;
            }

            if(this.mesInicial == null){
                this.mesInicial = 1;
            }

            if(this.mesFinal == null){
                this.mesFinal = 12;
            }
        },
        anoFinal : function(valor){
            if(this.anoInicial > valor){
                this.anoInicial = valor;
            }
        },
    },
    computed : {
        mesesFiltrado : function(){
            if(this.anoInicial != null){
                return this.meses.filter(el => el.value != null);
            }

            return this.meses;
        },

        anosFiltrado : function(){
            if(this.anoInicial != null){
                return this.anos.filter(el => el != null);
            }

            return this.anos;
        }
    }
}
</script>
<style lang="">
    
</style>